import { Service } from "../src/store/service";
const Api = new Service();

export async function fetchSuperkidsParentsKids() {

  try {
    // 1. Fire both API requests simultaneously
    const [resParents, resCoach] = await Promise.all([
      Api.getRequest(`fetch-parent-kids`),
      Api.getRequest(`fetch-coach-kids`) 
    ]);
  
    if (resParents?.data?.success && resCoach?.data?.success) {
      
      // 2. Extract arrays directly from responses
      const parentData = resParents.data.data || []; 
      const coachData = resCoach.data.data || [];
  
      // 3. Inject the single 'type' key into the array elements
      const parentKids = parentData.map((item: any) => ({ ...item, relationship: 'Child' }));
      const coachKids = coachData.map((item: any) => ({ ...item, relationship: 'Mentee' }));
  
      // 4. Merge both arrays into one
      const mergedData = [...parentKids, ...coachKids];
  
      // 5. Update local storage with the first item only
      const storedKids = localStorage.getItem('kidDetails');
      if ((!storedKids || storedKids === 'undefined') && mergedData.length > 0) {
        localStorage.setItem("kidDetails", JSON.stringify(mergedData[0])); // Saves the first item
        window.dispatchEvent(new Event('storage-update'));
      }
  
      // 6. Return the primary response structure containing the fully merged array
      return {
        ...resParents,
        data: mergedData
      };
    }
  } catch (error) {
    console.log("err:", error);
    throw error; 
  }

  // try {
  //   const res = await Api.getRequest(`fetch-parent-kids`);
  //   // console.log("response kidsss", res.data.data);
  //   if (res.data.success) {
  //     if ((!localStorage.getItem('kidDetails')) && (res.data.data.length > 0) || (localStorage.getItem('kidDetails') == undefined)) {
  //       localStorage.setItem("kidDetails", JSON.stringify(res.data.data[0]));
  //       window.dispatchEvent(new Event('storage-update'));
  //     }
  //     return res; 
  //   }
  // } catch (error) {
  //   console.log("err:", error);
  //   throw error; // Re-throw so the component knows there was an error
  // }
}
